interface StorefrontHeaderProps {
  navigate: (path: string) => void;
}

export function StorefrontHeader({ navigate }: StorefrontHeaderProps) {
  const openShop = () => navigate('/shop');
  const openHowItWorks = () => navigate('/#how-it-works');
  const openAccount = () => navigate('/account');

  return (
    <header className="store-header">
      <button
        className="store-brand"
        type="button"
        aria-label="Wild Trails Kids home"
        onClick={() => navigate('/')}
      >
        <img src="/art/brand/wild-trails-kids-logo.svg" alt="" aria-hidden="true" />
      </button>
      <nav className="store-desktop-nav" aria-label="Primary navigation">
        <button type="button" onClick={openShop}>
          Bracelets
        </button>
        <button type="button" onClick={openHowItWorks}>
          How it works
        </button>
        <button type="button" onClick={openAccount}>
          Grown-up area
        </button>
      </nav>
      <div className="store-mobile-actions">
        <details className="store-mobile-nav">
          <summary>Menu</summary>
          <nav aria-label="Mobile navigation">
            <button type="button" onClick={openShop}>
              Browse bracelets
            </button>
            <button type="button" onClick={openHowItWorks}>
              How it works
            </button>
            <button type="button" onClick={openAccount}>
              Grown-up area
            </button>
          </nav>
        </details>
      </div>
    </header>
  );
}
